/**
* In this file contains the Chat screen UI designs and message forms functionality
**/
import { Link } from 'react-router-dom';
import ApiService from './../../services/ApiService';
import { useState, useEffect } from 'react';
import {generateSharedKey,generatePrivateKey,generatePasswordEPK,convertS3privateToPublic,lastSeen,getMessageDate} from './../../services/UtilsService';
import Socket from './../../services/SocketService';
import moment from 'moment';
import { dataURItoBlob } from './../../services/UtilsService';
import { toast } from 'react-toastify';
import { goBack } from './../../services/UtilsService';
import CameraModal from './../../shared/modals/CameraModal';
import constantVariables from './../../dataset/constantVariables.json';
import { useSelector } from 'react-redux';

function Chat () {
	
	//To initialize the useState variables
	const [chatForm,setChatForm]=useState({});
	const [sharedKey,setSharedKey]=useState();
	const [chartHistory,setChartHistory]=useState([]);
	const [contactlist,setContactlist]=useState([]);
	const [user,setUser]=useState({});
	const [onlineUsr,setOnlineUsr]=useState([]);
	const [activeList,setActiveList]=useState(0);
	const [decryptedHistory,setDecryptedHistory]=useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [stopLoading, setStopLoading] = useState(false);
	const [param,setParam]=useState({page:0,limit:10});
	const [metaData,setMetaData]=useState({});
	const [show,setShow] = useState(false);
	const [video, setVideo] = useState(false);
	const profileData=useSelector(state => state?.profile);
	
	//To get the privateKey using localStorage
	const privateKey=localStorage.getItem('privateKey');
	
	//To find the current URL 
	const currentUrl = window.location.href;
	
	//To handle open camera modal
	const isOpen = () => {
		setShow(true);
	}
	
	//To handle close camera modal
	const handleClose = () => {
		setShow(false);
	}
	
	useEffect(()=>{
		/** 
		* To load the socket Message 
		* @message we receive the latest sended message details in Object format
		**/
		Socket.getMessage(async (message)=>{
			if (Object.keys(message).length !== 0 && chartHistory !== undefined) {
				const decryptedMsg = generatePrivateKey(sharedKey, message.message);
				const decryptedMessage = { ...message, decryptedMessage: decryptedMsg };
				await setDecryptedHistory(decryptedHistory => [...decryptedHistory, decryptedMessage]);
				await scrollToBottom();
				await setChatForm({});
				await setMetaData({});
			}
		});
	
		 
		 /** 
		 * To load Online Users 
		 * @user we get all online available user uuid in array format
		 **/
		Socket.getOnlineUsers(async (user)=>{
			await setOnlineUsr(user);
		 });
		 
		 /** 
		 * To Get contact message count
		 * @data we get the unread message count based on the count list the receiving value in array format
		 **/
		 Socket.getContactChatCount((data) => {
		 
		  if (data.length !==0) {
			const updatedArray = contactlist.map((item) => {
			  const foundItem = data.find(i => i.id === item.id);
			  if (foundItem) {
				return { ...item, count: foundItem.count };
			  }
			  return item;
			});
			setContactlist(updatedArray);
		  }
		 });
		 
		 /** 
		 * To remove the Message using the deleted message id 
		 * @value we receive the deleted message uuid
		 **/
		Socket.getDeleteMessageId(async (value)=>{
			if (value) {
				await setChartHistory((chartHistory) => chartHistory.filter(item => item.id !== value));
				await setDecryptedHistory((decryptedHistory) => decryptedHistory.filter(item => item.id !== value));
			}
		 });
		 
	});
	
	//Component Initialize function
	useEffect(()=>{
			loadContact();
			setChatForm({});
			setMetaData({});
			Socket.getOnlineUsersOnload(); 
			return () => {
				sessionStorage.clear();
				Socket.leaveChat(); 
			};
	// eslint-disable-next-line
	},[]);
	
	/** To load the contact List **/
  const loadContact=async ()=>{
    const response=await ApiService.getchatContactList();
	if(response.status===200){
		var index = 0;
		const updatedArray = [...response.data['items']];
		if(sessionStorage.getItem('user')){
			var sessionId = sessionStorage.getItem('user');
			index = updatedArray.findIndex(item => item.parent=== sessionId);
			setActiveList(index);
			sessionStorage.clear();
		}
		else{
			index=activeList;
		}
		
		updatedArray[index].count = '0';
		setContactlist(updatedArray);
		if(response.data['items'].length !==0){
			const id=currentUrl.includes('/physician') ? response.data['items'][index]['parent'] : response.data['items'][index]['physician'];
			const name=response.data['items'][index]['fullName'];
			const photo=response.data['items'][index]['photo'];
			const active=response.data['items'][index]['lastActive'];
			setUser({ ...user,id:id,name:name,photo:photo,active:active});
			loadChat(id,param,true);
			const sKey = await generateSharedKey(privateKey, response.data['items'][index]['publicKey']);
			setSharedKey(sKey);
	  }
	}
  }
  
  
     /** 
	 * To get the chat history 
	 * @data we receive the participant uuid
	 * @params we get the page and limit counts
	 * @value we get boolean value for scroll down to bottom screen
	 **/
  const loadChat=async (data,params,value)=>{
	  const isScroll=value;
	  //To join chat room
	   Socket.joinChat(data);
	   params.participants=[data,localStorage.getItem('userId')]; 

	   //To show history message
		var response = await ApiService.getChatHistory(data,params);
			if(response.data['items'].length < 10){
				  await setStopLoading(true);
			  }
			if (response.status === 200) {
				if(response.data['items'].length !==0){
					const message = response.data['items'];
					  setChartHistory((chartHistory) => [
							...message,
							...chartHistory,
						]);
					  const sKey = await generateSharedKey(privateKey, response.data['publicKey']);
					  const decryptedHistoryValue = message.map((msg) => {
						const decryptedMsg = generatePrivateKey(sKey, msg.message);
						return { ...msg, decryptedMessage: decryptedMsg };
					  });
					  await setParam({page:params.page+10,limit:10});
					  await setDecryptedHistory((decryptedHistory) => [
								...decryptedHistoryValue,
								...decryptedHistory,
						]);
						if(isScroll && isScroll===true)
							await scrollToBottom();			
				}else{
					if(chartHistory && chartHistory.length ===0){
						await setChartHistory([]);
						await setDecryptedHistory([]);	
					}
				}
			} else {
			  console.log('Error', response);
			}
			await setIsLoading(false);
  }
	
	/* To scroll bottom of the chat screen*/
  const scrollToBottom = () => {
	  setTimeout(() => {
		const element = document.getElementById('scrollDr');
		if (element) {
		  element.scrollIntoView({ behavior: 'smooth', block: 'end' });
		}
	  }, 100);
	};
	
	/** 
	* To load prevoius message we hit the top of the load chat screen
	* @e we get the div tag events
	**/
	const scrollUp = async (e) => {
		e.preventDefault();
		const target = e.target;
		if (target.scrollTop === 0 && stopLoading === false && decryptedHistory.length >9) {
		  await loadChat(user.id,param);
		}
	}

  
  /** 
  * To send message to patient 
  * @e we get the form events
  **/
  const sendMsg= async (e)=>{
	  e.preventDefault();
       var data:any={}
	   if(chatForm && chatForm.message && chatForm.message.trim()!==''){
		   document.getElementById("message").style.borderColor = "#e5e3e3";
			 data.message=await generatePasswordEPK(sharedKey,metaData.content_name ? metaData.content_name :chatForm.message);
			 data.recipients=[user.id];
			 data.participants=[user.id,localStorage.getItem('userId')];
			 data.content_type=metaData.content_type ? metaData.content_type :'text';
			 Socket.sendMessage(data);
		}else{
			document.getElementById("message").style.borderColor = "red";
		}
  }
  
  /** 
  * To press enter key and call sendMsg function to send the message 
  * @e we get the keyboard event
  **/
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMsg(e);
    }
  };  
  
  /** 
  * To select patient from contact List 
  * @id we pass the selected contactlist user uuid
  * @name we pass the selected contactlist user name
  * @i we pass the selected contactlist user array index value
  * @publicKey we pass the selected contactlist user publicKey
  * @photo we pass the selected contactlist user photo value
  * @recordId we pass the selected contactlist user record Id
  * @active we pass the selected contactlist user last available date value in timestamp format
  **/
  const selectList=async (id,name,i,publicKey,photo,recordId,active)=>{
		await setChatForm({});
	    Socket.leaveChat(); 
		scrollToBottom();
		await setChartHistory([]);
		await setDecryptedHistory([]);
		await setParam({page:0,limit:10});
		await setStopLoading(false);
		await setIsLoading(true);
	 const sKey = await generateSharedKey(privateKey, publicKey);
	setSharedKey(sKey);
    setActiveList(i);
    setUser({...user,name:name,id:id,photo:photo,active:active});
	const updatedArray = contactlist.map((item) => {
			  if (item.id === recordId ) {
				return { ...item, count: '0' };
			  }
			  return item;
			});
	await setContactlist(updatedArray);
	await loadChat(id,{page:0,limit:10},true);
  }
  
  /** 
  * To search the patient form contact list 
  * @we pass the input field events
  **/
  const searchPatient=(e)=>{
	var val =e.target.value;
	const filteredContacts = contactlist.filter((a) => a['fullName'].toLowerCase().includes(val));
	setContactlist(filteredContacts);
	if (val === '') 
		loadContact();
  }
  
  /** 
  * To handle the image crop
  * @we pass the input file events
  **/
  const handleFile=async (e)=>{
	  e.preventDefault();
	  const file = e.target.files[0];
	 if(file){
		 if (file.size > 5242880) {
			toast.error('Size Should be less than or equal to 5 MB');
				 return;
		}
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = async () => { 
			const cropImge=reader.result;
			if (cropImge !== undefined) {
				const formData = new FormData();
				const fileConvertData =await dataURItoBlob(cropImge);
				formData.append('file', fileConvertData);
				const response = await ApiService.uploadChatAttachment(formData);
				if(response.status===200 && response?.data?.filesName){
					await setChatForm({message:response.data.filesName});
					await setMetaData({content_type:response.data.filesName.split('.').pop(),content_name:response.data.filesName});
				}
			}
		};
	 }
  };
  
  /** 
  * To handle delete chat message
  * @id we pass the particular message record id
  * @userId we pass the user's uuid
  **/
  const handelAlert = async (id,userId) => {
    const result = window.confirm('Are you sure you want to delete?');
    if (result) {
		var response = await ApiService.deleteChatMessage(id);
		if(response.status===200){
			await setChartHistory((chartHistory) => chartHistory.filter(item => item.id !== id));
			await setDecryptedHistory((decryptedHistory) => decryptedHistory.filter(item => item.id !== id));
			await Socket.deleteMessage(id,userId);
		}
    } 
  };
  
  /**
  * To handle web cam image capture
  * @capturedImageUrl we ge the Image's base 64 bit format value
  **/
  const handleImageCapture = async (capturedImageUrl) => {
	  const formData = new FormData();
	  const fileConvertData =await dataURItoBlob(capturedImageUrl);
	  formData.append('file', fileConvertData);
		const response = await ApiService.uploadChatAttachment(formData);
			if(response.status===200 && response?.data?.filesName){
				await setChatForm({message:response.data.filesName});
				await setMetaData({content_type:response.data.filesName.split('.').pop(),content_name:response.data.filesName});
			}
  }
  
  useEffect(() => {
		//To check media device
	   navigator.mediaDevices?.enumerateDevices()
      .then((devices:any)=>{
        devices.forEach((device)=>{	
		    if(device.kind ==='videoinput'){
			   setVideo(true);
			}
		});
        });
  }, []);

 
  return (
  <main id="main" className="main">
  {/*<!-- Page Title Section -->*/}
		<div className="pagetitle clearfix">
			<div className="float-start">
			  <h1>{constantVariables.sidebar.messages}</h1>
				<nav>
					<ol className="breadcrumb">
					  <li className="breadcrumb-item"><Link to={currentUrl.includes('/physician/') ? '/physician/dashboard' : '/parent/dashboard' }>{constantVariables.sidebar.home}</Link></li>
					  <li className="breadcrumb-item active">{constantVariables.sidebar.messages} </li>
					</ol>
				</nav>
			</div>
			<div className="float-end mt-2 me-1">
				<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
			</div>
			{/*<!-- End Buttons -->*/}
		</div>
		{/*<!-- End Page Title Section -->
		<!-- Page Content Section -->*/}
		<section className="pagesection p-0">
			<div className="row">
				<div className="col-lg-12" style ={{height:"35pc"}}>
					<div className="chat-app">
					{/*Contact list Screen*/}
						<div id="plist" className="people-list">
							<div className="input-group mb-3">
								<span className="input-group-text" id="basic-addon1"><i className="ri-search-line"></i></span>
								<input type="text" className="form-control" onChange={searchPatient} placeholder="Search"/>
							</div>
							<ul className="list-unstyled chat-list mt-2 mb-0 clearfix">
							 {contactlist && contactlist.length !==0 && contactlist.map((i,idx)=>(
								<li key={i.id} className={idx===activeList ? 'itemss d-flex align-items-center justify-content-start active' : 'itemss d-flex align-items-center justify-content-start'} onClick={()=>selectList(currentUrl.includes('/physician/') ? i?.parent:i?.physician,i?.fullName,idx,i?.publicKey,i?.photo,i?.id,i?.lastActive )}>
									{i?.photo==='default.png'?<img src="/assets/img/user-avatar.png" style={{width:"40px",height:"40px",borderRadius:"50%",marginRight:"0.5rem"}} alt="Profile" />:<img style={{width:"40px",height:"40px",borderRadius:"50%",marginRight:"0.5rem"}} src={convertS3privateToPublic(i?.photo)} alt="Profile" />}
									<div className="about">
										<div className="name  text-capitalize">{i?.fullName}</div>
										{onlineUsr.length !== 0 && onlineUsr.includes(currentUrl.includes('/physician/')?i?.parent:i.physician) ? (
										  <div className="status">
											 <i className="ri-checkbox-blank-circle-fill online text-capitalize"></i> Online
										  </div>
										) : (
										  <div className="status">
											 <i className="ri-checkbox-blank-circle-fill offline"></i><span style={{padding:'4px'}} className="text-capitalize">{i?.lastActive ? lastSeen(i.lastActive) : 'offline'}</span>
										   </div>
										)}
									</div>
									{i?.count !=='0' && <span className="badge bg-danger" style={{marginLeft:'auto'}}>{i?.count}</span>}
								</li>     
						     ))}
						     {contactlist?.length===0 &&  <li className="text-center" >No Contact found</li>}
							</ul>
						</div>
						{/*End Contact list Screen*/}
						
						{/*Message Screen*/}
						{contactlist?.length !==0 &&  <div className="chat">
							<div className="chat-header clearfix">
								<div className="row">
									<div className="col-lg-6">
										<Link data-toggle="modal" data-target="#view_info">
											{user?.photo==='default.png'?<img src="/assets/img/user-avatar.png" style={{width:"40px",height:"40px",borderRadius:"50%",marginRight:"0.5rem"}} alt="Profile" />:<img src={convertS3privateToPublic(user?.photo)} style={{width:"40px",height:"40px",borderRadius:"50%",marginRight:"0.5rem"}} alt="Profile" />}
										</Link>
										<div className="chat-about">
											<h6 className="m-b-0 text-capitalize">{user?.name}</h6>
											{onlineUsr.length !==0 && onlineUsr.includes(user?.id) ? (
											 <small className="text-capitalize">online</small>
											 ):(
											 <small className="text-capitalize"> {user?.active ? lastSeen(user?.active) : 'offline'}</small>
											)}
										</div>
									</div>
									<div className="col-lg-6 text-end">
										{video && <span className="btn btn-outline-tmBlue px-3 mx-1" onClick={isOpen} style={{borderRadius:'8px'}}><i className="ri-camera-fill align-middle"></i></span> }
										{show===true && <CameraModal show={show} handleClose={handleClose} handleImageCapture={handleImageCapture}/>}
										<label className="btn btn-outline-tmPink px-3" style={{ borderRadius: '8px' }}>
										  <input type="file" onChange={handleFile} style={{ display: 'none' }} name="file-6[]" id="file-6" className="inputfile inputfile-5" />
										  <span style={{ fontSize: '15px', verticalAlign: 'middle', marginTop: '2px' }}> <i className="ri-image-2-fill align-middle" style={{ padding: '2px' }}></i> </span>
										</label>
										{/*<a href="#" className="btn btn-outline-secondary px-3"><i className="ri-settings-3-fill align-middle"></i></a>*/}
									</div>
								</div>
							</div>
							<div className="chat-sec">
					         <div className="chat-history" id="scrollTop" onScroll={(e) => scrollUp(e)}>
							  <ul className="m-b-0">
							  {isLoading ? (
							   <li className="text-center">Loading...</li>
							   ) : (
							   decryptedHistory && decryptedHistory.length !== 0 ? (
								decryptedHistory.map((m) => (
								  <li className="clearfix" key={m.id}>
									{currentUrl.includes('/physician/') ? (
									  <div className={m.role === 2 ? 'message-data text-end float-end' : ''}>
										<div className='message-data'>
										  {m.role===1 && user?.photo && (user?.photo==='default.png'?<img src="/assets/img/user-avatar.png" style={{width:"40px",height:"40px",borderRadius:"50%",marginRight:"0.5rem"}} alt="Profile" />:<img src={convertS3privateToPublic(user?.photo)} style={{width:"40px",height:"40px",borderRadius:"50%",marginRight:"0.5rem"}} alt="Profile" />)}
										  <span className="message-data-time m-1">{moment(m.createdAt).format('h:mm A')}, {getMessageDate(m.createdAt)}</span>
										  {m.role===2 && profileData && profileData?.photo && (profileData?.photo==='default.png'?<img src="/assets/img/user-avatar.png" style={{width:"40px",height:"40px",borderRadius:"50%",marginRight:"0.5rem"}} alt="Profile" />:<img src={convertS3privateToPublic(profileData?.photo)} style={{width:"40px",height:"40px",borderRadius:"50%",marginRight:"0.5rem"}} alt="Profile" />)}
										</div>
										<div className={m.role === 2 ? 'message other-message float-end' : 'message my-message'}>
										  {m.content_type === 'text' && <div>{m.decryptedMessage}</div>}
										  {m.content_type !== 'text' && m.decryptedMessage && (
											<div className="msg-media">
											  {m.role === 2 && <span style={{ float: "right", fontWeight: "900",cursor:'pointer' }} onClick={() => handelAlert(m.id,m.recipients[0])}><i className="ri-close-line"></i></span>}
											  <a target="_blank" rel="noreferrer" href={convertS3privateToPublic(m.decryptedMessage, 3600)} download>
												{['jpg', 'jpeg', 'png', 'JPEG'].includes(m.content_type) && (<img style={{ width: "80px",borderRadius:0 }} src={convertS3privateToPublic(m.decryptedMessage, 3600)} alt="IMG" />)}
												{m.content_type === 'pdf' && (<img style={{ width: "80px",borderRadius:0 }} src="/assets/img/nurturepdf.jpg" alt="IMG" />)}
												{['document', 'msword', 'doc', 'docx'].includes(m.content_type) && (<img style={{ width: "80px",borderRadius:0 }} src="/assets/img/nurtureword.jpg" alt="IMG" />)}
												{['mp4', 'avg', 'mkv'].includes(m.content_type) && (<img style={{ width: "80px",borderRadius:0 }} src="/assets/img/nurturevideo.png" alt="IMG" />)}
												<div style={{ width: "90px", height: "20px", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
												  <p>{m.decryptedMessage}</p>
												</div>
											  </a>
											</div>
										  )}
										</div>
									  </div>
									) : currentUrl.includes('/parent/') ? (
									  <div className={m.role === 2 ? '' : 'message-data text-end float-end'}>
										<div className='message-data'>
										  {m.role===2 && user?.photo && (user?.photo==='default.png'?<img src="/assets/img/user-avatar.png" style={{width:"40px",height:"40px",borderRadius:"50%",marginRight:"0.5rem"}} alt="Profile" />:<img src={convertS3privateToPublic(user?.photo)} style={{width:"40px",height:"40px",borderRadius:"50%",marginRight:"0.5rem"}} alt="Profile" />)}
										  <span className="message-data-time m-1">{moment(m.createdAt).format('h:mm A')}, {getMessageDate(m.createdAt)}</span>
										  {m.role===1 && profileData && profileData?.photo && (profileData?.photo==='default.png'?<img src="/assets/img/user-avatar.png" style={{width:"40px",height:"40px",borderRadius:"50%",marginRight:"0.5rem"}} alt="Profile" />:<img src={convertS3privateToPublic(profileData?.photo)} style={{width:"40px",height:"40px",borderRadius:"50%",marginRight:"0.5rem"}} alt="Profile" />)}
										</div>
										<div className={m.role === 2 ? 'message my-message' : 'message other-message'}>
										  {m.content_type === 'text' && <div>{m.decryptedMessage}</div>}
										  {m.content_type !== 'text' && m.decryptedMessage && (
											<div className="msg-media">
											  {m.role === 1 && <span style={{ float: "right", fontWeight: "900",cursor:'pointer' }} onClick={() => handelAlert(m.id,m.recipients[0])}><i className="ri-close-line"></i></span>}
											  <a target="_blank" rel="noreferrer" href={convertS3privateToPublic(m.decryptedMessage)} download>
												{['jpg', 'jpeg', 'png', 'JPEG'].includes(m.content_type) && (<img style={{ width: "80px",borderRadius:0 }} src={convertS3privateToPublic(m.decryptedMessage)} alt="IMG" />)}
												{m.content_type === 'pdf' && (<img style={{ width: "80px",borderRadius:0 }} src="/assets/img/nurturepdf.jpg" alt="IMG" />)}
												{['document', 'msword', 'doc', 'docx'].includes(m.content_type) && (<img style={{ width: "80px",borderRadius:0 }} src="/assets/img/nurtureword.jpg" alt="IMG" />)}
												{['mp4', 'avg', 'mkv'].includes(m.content_type) && (<img style={{ width: "80px",borderRadius:0 }} src="/assets/img/nurturevideo.png" alt="IMG" />)}
												<div style={{ width: "90px", height: "20px", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
												  <p>{m.decryptedMessage}</p>
												</div>
											  </a>
											</div>
										  )}
										</div>
									  </div>
									) : null}
								  </li>
								))
							  ) : (
								<li className="text-center">{constantVariables.common.noRecord}</li>
							  )
							)}
							<li id="scrollDr"></li>
						   </ul>
						   </div>
						  </div>
							<div className="chat-message clearfix">
							  <form onSubmit={sendMsg}>
								<div className="input-group">
								  <textarea className="form-control" id="message" name="message" onChange={(e)=> setChatForm({...chatForm,[e.target.name]:e.target.value})}  onKeyDown={handleKeyDown} onPaste={(e)=>e.preventDefault()}  value={chatForm.message?chatForm.message:''}></textarea>
								  <button  type="submit" className="input-group-text"><i className="ri-send-plane-fill me-2"></i> Send Message</button>
								</div>
							   </form>
							</div>
						</div>}
						{contactlist?.length ===0 &&  <div>
							<h5 style={{position:"fixed"}} className="noRecords">No chat Found</h5>
						</div>}
						{/*End Message Screen*/}
					</div>
				</div>
			</div>
		</section>
		{/*<!-- End Page Content Section -->*/}
	</main>
  );
}

export default Chat;
